import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { OpeningApi } from '../api/openingApi';

class OpeningCopyButton extends React.Component {
  constructor(props) {
    super(props);

    const { dispatch } = this.props;

    this.handleClick = this.handleClick.bind(this);
    this.openingApi = new OpeningApi(dispatch);
  }

  handleClick() {
    const { opening } = this.props;

    this.openingApi.create(opening);
  }

  render() {
    const { opening, status } = this.props;
    const disabled = status=== "copied" ? true : false;

    return(
      <>
        {opening.san_moves.join(", ")}
        <button type="button" className="btn btn-primary btn-lg" onClick={this.handleClick} disabled={disabled}>
          {disabled && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
          Copy to Analysis Board
        </button>
        {status === "copied" && <p className="text-success bg-light">Copied, redirecting to your new board</p>}
      </>
    )
  }
}

OpeningCopyButton.propTypes = {
  opening: PropTypes.object.isRequired, // Ensure opening is an object
  dispatch: PropTypes.func.isRequired,  // Ensure dispatch is a function
  status: PropTypes.string.isRequired, // Ensure status is a string
};

function mapStateToProps(state) {
  const { opening, openingCopyButton } = state;
  const { status } = openingCopyButton;

  return { opening, status };
}

export default connect(mapStateToProps)(OpeningCopyButton);
